import React from 'react';
import PropTypes from 'prop-types';
import '@fiverr/i18n/singleton';

const SellerCountry = ({ country, comma }) => (
    <span className="seller-country">
        {comma ? ', ' : ''}
        {i18n.t('general.from')} {country}
    </span>
);

SellerCountry.propTypes = {
    country: PropTypes.string,
    comma: PropTypes.bool
};

export default SellerCountry;



// WEBPACK FOOTER //
// ./src/shared/seller_country/index.js